import { useTranslations } from "next-intl";
import getDescriptionData from "src/helpers/getDescriptionData";
import { ProductType } from "src/types/product-types/ProductType";

interface ProductDescriptionProps {
  handle: string;
}

const ProductDescription = ({ handle }: ProductDescriptionProps) => {
  const t = useTranslations("ProductOverview");
  const descriptionData = getDescriptionData(handle);

  if (descriptionData?.type === ProductType.TravelBag) {
    return (
      <>
        <p>{t(descriptionData.description)}</p>
        <p>{t(descriptionData.dimensions)}</p>
      </>
    );
  } else if (descriptionData?.type === ProductType.WashBag) {
    return (
      <>
        <p>{t(descriptionData.description)}</p>
        <p className="font-semibold">{t(descriptionData.features_title)}</p>
        <ol className="space-y-2">
          {descriptionData.features?.map((feature: string) => (
            <li key={feature}>
              {t.rich(feature, { b: (chunks) => <b>{chunks}</b> })}
            </li>
          ))}
        </ol>
        <p>{t(descriptionData.dimensions)}</p>
      </>
    );
  } else if (descriptionData?.type === ProductType.GiftCard) {
    return (
      <>
        <ol className="space-y-2">
          {descriptionData.descriptions?.map((description) => (
            <li key={description}>{t(description)}</li>
          ))}
        </ol>
        <p>{t(descriptionData.uses_title)}</p>
        <ol className="list-disc space-y-1 ps-4">
          {descriptionData.uses?.map((giftCardUse) => (
            <li key={giftCardUse}>{t(giftCardUse)}</li>
          ))}
        </ol>
        <ol>
          {descriptionData.additionalInformation?.map((information) => (
            <li key={information}>{t(information)}</li>
          ))}
        </ol>
      </>
    );
  } else {
    return <p>{t(descriptionData?.description)}</p>;
  }
};

export default ProductDescription;
